import React from 'react'
import Transition from '../Transition'

class TransitionWrapper extends React.Component {
    render() {
        const { children, root } = this.props

        return (
            <Transition root={root}>
                {children}
            </Transition>
        )
    }
}

export default TransitionWrapper



// WEBPACK FOOTER //
// ./src/components/wrappers/TransitionWrapper.js